export const ICON_SIZE = 16;

export const DISPLAY_NAMES: Record<string, string> = {
  macos: 'macOS',
  ios: 'iOS',
  windows: 'Windows',
  android: 'Android',
  chrome: 'Chrome',
  firefox: 'Firefox',
  safari: 'Safari',
  edge: 'Edge',
};

export const DEFAULT_ORDER_BY = 'createTime:desc';

export const COLUMNS = [
  { id: 'summary', label: 'Summary', compact: false, hiddenInCompact: false },
  { id: 'journey', label: 'Journey', compact: true, hiddenInCompact: true },
  { id: 'os', label: 'OS', compact: true, hiddenInCompact: true },
  { id: 'browser', label: 'Browser', compact: true, hiddenInCompact: true },
  { id: 'length', label: 'Length', compact: false, hiddenInCompact: true },
] as const;
